<template>
  <b-nav-item-dropdown
    id="announcement"
    :class="allAnnouncements.length === 0 || hasOnlySeenAnnouncements ? '' : 'ring-bell'"
    menu-class="scrollable-menu pb-3"
    right>
    <template slot="button-content">
      <font-awesome-icon :icon="['fas', 'bell']"
                         size="lg" />
    </template>
    <template v-if="allAnnouncements.length === 0">
      <b-dropdown-text
        class="limited-width-text">
        {{ $t('app.navbar.noAnnouncement') }}
      </b-dropdown-text>
    </template>
    <b-container
      v-for="announcement in allAnnouncements"
      :key="announcement.id">
      <b-dropdown-text>
        <div
          v-dompurify-html="announcement.content"
          class="limited-width-text announcement-item"
          @click="openModal(`announcementModal${announcement.id}`)" />
        <hr v-if="announcement !== allAnnouncements[allAnnouncements.length - 1]"/>
      </b-dropdown-text>
      <announcement-modal
        :ref="`announcementModal${announcement.id}`"
        :announcement="announcement" />
    </b-container>
  </b-nav-item-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import AnnouncementModal from './AnnouncementModal.vue';

export default {
  components: { AnnouncementModal },
  computed: {
    ...mapState('announcement', {
      allAnnouncements: state => state.allAnnouncements,
      announcementsSeen: state => state.announcementsSeen,
      initDisplayCallToAction: state => state.initDisplayCallToAction
    }),
    hasOnlySeenAnnouncements() {
      return this.allAnnouncements.length > 0 && this.allAnnouncements.every(announcement => this.announcementsSeen.includes(announcement.id));
    }
  },
  mounted() {
    this.$store.dispatch('announcement/getAllAnnouncements').then(() => {
      this.$store.dispatch('announcement/getCurrentAnnouncements').then(() => {
        this.$store.dispatch('announcement/initAnnouncementsSeen');
      }).catch(() => {});
    }).catch(() => {});
  },
  methods: {
    openModal(modalName) {
      this.$refs[modalName][0].showModal();
    }
  }
};
</script>

<style>
.announcement-item {
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color .15s ease;
}

.announcement-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.announcement-item p {
  margin-bottom: 0;
}

.b-dropdown-text hr {
  margin-top: 0.5rem;
  margin-bottom: 0;
}
</style>
